import React from 'react'
import { useSelector } from 'react-redux'
import { selectActiveLanguage } from '@/store/app'
import './currency.scss'
import { useCurrencies } from '@/hooks'
import CurrencyIcon from '@/components/currencyIcon'
import NumberFlow from '@number-flow/react'
import { useCurrencyDisplay } from './CurrencyDisplayContext'
function Currency({
  value,
  currency = 'OOM',
  mode,
  ratio,
  decimalPlaces,
  keepZeros = true,
  showSuffix = true,
  showPrefix = true,
  suffixSpace = true,
  color,
  showIcon = false,
  roundingMode = 'floor',
  className = '',
  valueClassName = '',
  noNumberFlow = false,
  ...props
}) {
  const currencies = useCurrencies().currencies
  let locale = useSelector(selectActiveLanguage(props.locale))
  const { stableAsDollar } = useCurrencyDisplay()

  const currencyObject = currencies[currency]

  if (!currencyObject) return

  let currencyRatio = ratio || currencyObject.display_ratio
  let defaultDecimalPlaces = currencyObject.display_decimal_places || 2 // - Math.abs(Math.log10(currencyRatio))
  // ?? so an explicit decimalPlaces={0} is respected instead of falling back
  let maximumFractionDigits = decimalPlaces ?? defaultDecimalPlaces ?? 2
  let minimumFractionDigits = keepZeros ? maximumFractionDigits : 0
  let prefix = props.prefix || currencyObject.display_prefix

  let suffix = props.suffix || currencyObject.display_suffix
  if (!value) {
    value = 0
  }

  value /= currencyRatio

  if (mode === 'abbreviate') {
    maximumFractionDigits = 0
  }
  const currencyOptions = {
    locale: locale || 'en-US',
    value: value,
    format: { style: 'decimal', minimumFractionDigits, maximumFractionDigits, roundingMode },
  }
  // A stablecoin spelt as dollars: "$" hugs the number and the ticker suffix goes.
  const asDollar =
    stableAsDollar && showPrefix && currencyObject.is_stable === true && !props.prefix && !props.suffix
  if (asDollar) {
    currencyOptions.prefix = '$'
  } else if (showPrefix && prefix) {
    currencyOptions.prefix = prefix + ' '
  }
  if (!asDollar && showSuffix && suffix) {
    currencyOptions.suffix = suffixSpace ? ' ' + suffix : suffix
  }
  return (
    <div className={`currency__symbol ${className}`} style={{ color }}>
      {showIcon && <CurrencyIcon currency={currencyObject} width="13px" />}

      {!noNumberFlow && <NumberFlow {...currencyOptions} className={'currency__value w-max ' + valueClassName} />}
      {noNumberFlow && (
        <span className={'currency__value flex gap-1 w-max ' + valueClassName}>
          {/* An empty prefix or suffix still owns a gap, which reads as a stray space; a
              dollar sign shares the number's span so no gap opens between them. */}
          {currencyOptions.prefix && !asDollar && <span>{currencyOptions.prefix}</span>}
          <span>
            {asDollar && currencyOptions.prefix}
            {value.toLocaleString(currencyOptions.locale, currencyOptions.format)}
          </span>
          {currencyOptions.suffix && <span>{currencyOptions.suffix}</span>}
        </span>
      )}
    </div>
  )
}

export default Currency
